import React from 'react';

const AdminProfile = ({ data }) => {
     if (!data) return null;

     const safe = (val) => (val && val !== 'null' && val !== '0000-00-00' ? val : '-');
     const formatDate = (dateString) => {
          if (!dateString || dateString === '0000-00-00') return '-';
          const date = new Date(dateString);
          if (isNaN(date)) return '-';
          return date.toLocaleDateString();
     };

     const initials = data.comp_name
          ? data.comp_name.split(' ').map(n => n[0]).join('').toUpperCase()
          : (data.fname ? data.fname[0].toUpperCase() : 'U');

     return (
          <div style={{
               width: '100%',
               maxWidth: '1500px',
               margin: '4px auto',
               background: '#fff',
               borderRadius: '14px',
               boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
               padding: '0 0 24px 0'
          }}>
               {/* Header */}
               <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '18px',
                    padding: '20px 20px 10px 20px',
                    borderBottom: '1px solid #e5e7eb',
                    flexWrap: 'wrap'
               }}>
                    <div>
                         <div style={{ fontSize: 17, fontWeight: 700, color: '#222' }}>
                              {safe(data.comp_name) || `${safe(data.fname)} ${safe(data.lname)}`}
                         </div>
                         <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>
                              <span style={{ fontWeight: 600 }}>Emp Code:</span> {safe(data.emp_code)}
                         </div>
                         <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                              <span style={{ fontWeight: 600 }}>Designation:</span> {safe(data.designation_name) || safe(data.position)}
                         </div>
                    </div>
                    <div style={{
                         marginLeft: 'auto',
                         minWidth: 120,
                         textAlign: 'right'
                    }}>
                         <div style={{
                              fontSize: 13,
                              color: '#2563eb',
                              fontWeight: 600,
                              marginBottom: 2
                         }}>{safe(data.active)}</div>
                         <div style={{ fontSize: 12, color: '#64748b' }}>
                              <span style={{ fontWeight: 600 }}>Joined:</span> {formatDate(data.doj)}
                         </div>
                    </div>
               </div>

               {/* Main Info Grid */}
               <div
                    style={{
                         width: '100%',
                         display: 'grid',
                         gridTemplateColumns: 'repeat(4, 1fr)',
                         gap: '16px',
                         padding: '32px'
                    }}
                    className="admin-profile-grid"
               >
                    <InfoCard label="Mobile" value={safe(data.mobile)} icon="📱" />
                    <InfoCard label="Email" value={safe(data.mail_id)} icon="✉️" />
                    <InfoCard label="Gender" value={safe(data.gender)} icon="⚧" />
                    <InfoCard label="DOB" value={formatDate(data.dob)} icon="🎂" />

                    <InfoCard label="Department" value={safe(data.dept_name)} icon="🏢" />
                    <InfoCard label="OU Name" value={safe(data.ou_name)} icon="🏢" />
                    <InfoCard label="Location" value={safe(data.location_name)} icon="📍" />
                    <InfoCard label="Region" value={safe(data.region)} icon="🌎" />
                    <InfoCard label="Country" value={safe(data.country)} icon="🌏" />
                    <InfoCard label="City" value={safe(data.city)} icon="🏙️" />
                    <InfoCard label="Pay Group" value={safe(data.pay_group)} icon="💳" />
                    <InfoCard label="Position" value={safe(data.position)} icon="💼" />
                    {/* <InfoCard label="Bank Name" value={safe(data.bank_name)} icon="🏦" />
                    <InfoCard label="Bank #" value={safe(data.bank_acnum)} icon="🔢" />
                    <InfoCard label="IFSC" value={safe(data.ifsc_code)} icon="🏧" /> */}


               </div>

               {/* Responsive styles */}
               <style>{`
                @media (max-width: 1200px) {
                    .admin-profile-grid { grid-template-columns: repeat(3, 1fr) !important; }
                }
                @media (max-width: 900px) {
                    .admin-profile-grid { grid-template-columns: repeat(2, 1fr) !important; }
                }
                @media (max-width: 600px) {
                    .admin-profile-grid { grid-template-columns: 1fr !important; padding: 16px !important; }
                }
            `}</style>
          </div>
     );
};

const InfoCard = ({ label, value, icon }) => (
     <div style={{
          background: '#f8fafc',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          padding: '12px',
          minHeight: '50px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          boxShadow: '0 1px 2px rgba(0,0,0,0.02)'
     }}>
          <span style={{ fontSize: '13px', color: '#2563eb', fontWeight: 600, marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
               {icon} {label}
          </span>
          <span style={{ fontSize: '14px', color: '#222', fontWeight: 500 }}>{value}</span>
     </div>
);

export default AdminProfile;